// extracted by mini-css-extract-plugin
export default {"component":"Zs1IG"};